import { axiosInstance } from "../../../api/axios";

const projectPath = (groupCode, projectCode) =>
  `/risk/${encodeURIComponent(groupCode)}/${encodeURIComponent(projectCode)}`;

const asArray = (value) => (Array.isArray(value) ? value : []);

export const getSafetyOverview = async ({ groupCode, projectCode, date }) => {
  const basePath = projectPath(groupCode, projectCode);
  const currentDate = date instanceof Date ? date : new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const evalDate = [
    year,
    String(month).padStart(2, "0"),
    String(currentDate.getDate()).padStart(2, "0"),
  ].join("-");

  const requests = await Promise.allSettled([
    axiosInstance.get(`${basePath}/wizard/pending-hazards`, {
      params: { eval_date: evalDate },
    }),
    axiosInstance.get(`${basePath}/getRiskAssessmentApproval`),
    axiosInstance.get(`${basePath}/getStrategyRegister`, {
      params: { year, month, machine_id: "all" },
    }),
    axiosInstance.get(`${basePath}/getStrategyResult`, {
      params: { year, month, machine_id: "all", filter: "all" },
    }),
  ]);

  const value = (index, fallback) =>
    requests[index].status === "fulfilled"
      ? requests[index].value.data
      : fallback;

  return {
    pendingHazards: asArray(value(0, {})?.rows),
    evaluations: asArray(value(1, [])),
    improvementWaiting: asArray(value(2, [])),
    improvementCompleted: asArray(value(3, [])),
    hasError: requests.some((request) => request.status === "rejected"),
  };
};

export const getUpcomingSafetyEvents = async ({
  groupCode,
  projectCode,
  start,
  end,
}) => {
  const response = await axiosInstance.get(
    `${projectPath(groupCode, projectCode)}/calendar`,
    { params: { start, end } }
  );
  const data = response?.data;
  return data && typeof data === "object"
    ? { ...data, events: asArray(data.events) }
    : { events: [] };
};
